import { JoinTripInput } from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"

export const joinTrip = async (payload: JoinTripInput) => {
  const response = await callFirebaseFunction({
    name: "joinTrip",
    payload,
  })
  if (response.error) {
    throw new Error("Failed to join trip")
  }
  return response.data
}
